import * as Yup from 'yup';
import { followConfigFormModel } from './followConfigFormModel';

const {
    formField: {
        scoreThreshold
    }
} = followConfigFormModel;

export default [
    Yup.object().shape({
        [scoreThreshold.name]: Yup.number()
            .required(scoreThreshold.requiredErrorMsg)
            .min(1, 'El valor debe ser al menos 1')
            .max(5, 'El valor debe ser máximo 5')
            .typeError(scoreThreshold.invalidErrorMsg),
    })
];
